import { get } from 'lodash-es';

/**
 * `state.user` is `{}` until app boot resolves /app/house/user, so every access
 * flag reads falsy before then. Check this first or a permission guard flashes
 * "no access" on load.
 */
export const selectIsUserLoaded = state => Boolean(get(state, 'user.userRef'));

// Every accessX flag in updateUserTransformer (modules/user.js) is decoded from
// the `access.<letter>` lookup map, so the truthy value is literally 1 — the
// header compares them the same way. Keep that encoding in one place.
const selectAccess = flag => state => get(state, ['user', flag]) === 1;

export const selectAccessSensitive = selectAccess('accessSensitive');
